import React, { useState } from 'react';
import Card from 'components/v2/card/Card';
import CardFooter from 'components/v2/card/CardFooter';
import CardHeader from 'components/v2/card/CardHeader';
import { useTranslation } from 'react-i18next';
import { useCreateQuickPay } from 'hooks/quick-pay/useContracts';
import { showToast } from 'stores/ToastStore';
import moment from 'moment-timezone';
import ContractForm from './ContractForm';
export default function AddContractForm({ carrier, onCancel, activeTermsAndConditions = [] }) {
    const { t } = useTranslation();
    const [saving, setSaving] = useState(false);
    const onSaveSuccess = (response) => {
        var _a, _b;
        if ((_a = response === null || response === void 0 ? void 0 : response.validation_errors) === null || _a === void 0 ? void 0 : _a.length) {
            const { validation_errors: errors } = response;
            let errorMessages = '';
            if (errors.length === 1) {
                errorMessages = (_b = errors[0]) === null || _b === void 0 ? void 0 : _b.message;
            }
            else {
                errorMessages = errors.reduce((acc, { message }, idx) => acc + `${idx + 1}. ${message} \n`, '');
            }
            showToast(errorMessages, errorMessages, 'error');
            setSaving(false);
        }
        else if (response === null || response === void 0 ? void 0 : response.contract) {
            showToast(t('CREATE_QUICKPAY_SUCCESS'), t('CREATE_QUICKPAY_SUCCESS'), 'success');
            setSaving(false);
            onCancel();
        }
    };
    const onSaveFail = (error) => {
        var _a, _b;
        setSaving(false);
        const response = error === null || error === void 0 ? void 0 : error.entity;
        if (!(response === null || response === void 0 ? void 0 : response.success) && ((_a = response === null || response === void 0 ? void 0 : response.validation_errors) === null || _a === void 0 ? void 0 : _a.length)) {
            const { validation_errors: errors } = response;
            let errorMessages = '';
            if (errors.length === 1) {
                errorMessages = (_b = errors[0]) === null || _b === void 0 ? void 0 : _b.message;
            }
            else {
                errorMessages = errors.reduce((acc, { message }, idx) => acc + `${idx + 1}. ${message} \n`, '');
            }
            showToast(errorMessages, errorMessages, 'error');
        }
    };
    const { mutation } = useCreateQuickPay(onSaveSuccess, onSaveFail);
    function renderHeader() {
        return React.createElement(CardHeader, { title: t('ADD_CONTRACT') });
    }
    function renderFooter() {
        return (React.createElement(CardFooter, { onActionClick: () => {
                setSaving(true);
            }, onCancelClick: onCancel, actionTestDataId: "quickpay-add-save", cancelTestDataId: "quickpay-add-cancel" }));
    }
    const handleSave = async (newContract) => {
        const start_date = moment(newContract.start_date).format('YYYY-MM-DD');
        const end_date = moment(newContract.end_date).format('YYYY-MM-DD');
        newContract.end_date = end_date;
        newContract.start_date = start_date;
        const payload = Object.assign({ user: carrier }, newContract);
        setSaving(true);
        await mutation.mutateAsync(payload);
    };
    const onValidSuccess = (data) => {
        handleSave(data);
    };
    const onValidFail = () => {
        setSaving(false);
    };
    return (React.createElement(Card, { header: renderHeader, footer: renderFooter },
        React.createElement(ContractForm, { data: {}, saving: saving, onValidSuccess: onValidSuccess, onValidFail: onValidFail, activeTermsAndConditions: activeTermsAndConditions })));
}
